import styled from "styled-components";

export const SlideDeleteButtonBox = styled.button`
    background-color: ${props => props.theme.colors.danger};
    color: ${props => props.theme.colors.dangerContrast};
    font-size: ${props => props.theme.fontSize.h5};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    border-radius: 5px;
    

    svg {
        margin-left: 5px;
    }
`
